import React from 'react';
import { ContentContainer } from '../../_sections/Content/ContentContainer';
import { ContextSection } from '../../_sections/Context/ContextSection';
import { SectionWithWidgets } from '../../types/api/Sections';

type FullWidthContentProps = {
  contentSection: SectionWithWidgets;
  contextSection?: ContextSection;
};

/**
 * Renders the FullWidthContent Layout, which contains Content and Context Section.
 * Content section is always in full width.
 * ContextSection is in full width grid layout (modifier full-width), see SON-14058
 */
export function FullWidthContent({ contentSection, contextSection }: FullWidthContentProps) {
  return (
    <>
      <ContentContainer className="content-full" section={contentSection} />
      {contextSection && <ContextSection modifier="full-width" {...contextSection} />}
    </>
  );
}
